import { useState, useEffect } from "react";
import Modal from 'react-modal';
import useKeypress from "../ownHooks/pressEsc";
import { listDropdowns } from "../Tabellen/ConstTabKopf/AbschnittKopf";
import '../Tabellen/SD_anlegen/Formular.css';
import { MyCancelButton, MyNewButton, MySaveButton } from "../StyleSheets/GeneralButtonStyles";
import { MyModalButtons, MyModalCloseButton, MyModalContentDateInput, MyModalContentNumberInput, MyModalContentRow, MyModalContentSelectInput, MyModalContentTextInput, MyModalForm } from "../StyleSheets/ModalStyle";
import { FehlerauswertungErrResp } from "../Fehler/FehlerauswertungErrResp";


var MonitorApi = require('monitor-api');


export default function AbschnittNeu({ bhfInstance, absInstance, reloadData, kreisInstance, zvInstance, eiuInstance, strKatInstance }) {
    const [showModal, setShowModal] = useState(false);
    const [newAbschnitt, setNewAbschnitt] = useState(new MonitorApi.AbschnittCreate());
    const [bhfList, setBhfList] = useState([]);
    const [kreisList, setKreisList] = useState([]);
    const [zvList, setZvList] = useState([]);
    const [eiuList, setEiuList] = useState([]);
    const [strkatList, setStrkatList] = useState([]);


    useEffect(() => {
        bhfInstance.getListOfBahnhofsBahnhoflisteGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                console.log('>>load bhfListe');
                setBhfList(data);
            }
        });

        kreisInstance.kreisListeGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setKreisList(data);
            }
        });
        zvInstance.zweckverbandListeZweckverbandListeGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setZvList(data);
            }
        });
        eiuInstance.getEiuEisenbahninfraunternehmenGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setEiuList(data);
            }
        });
        strKatInstance.getStreckenkategorieStreckenkategorieGet((error, data) => {
            if (error) {
                console.log(error);
            } else {
                setStrkatList(data);
            }
        })

    }, [bhfInstance, kreisInstance, zvInstance, eiuInstance, strKatInstance]);

    const openModal = event => {
        setShowModal(true);
        setNewAbschnitt(new MonitorApi.AbschnittCreate());
    };


    const tinkerDropdowns = (what) => {
        switch (what) {
            case 'id_bhfbeginn':
                return (
                    <MyModalContentSelectInput name={what} onChange={e => addNew(e, what)} required>
                        <option key={0} defaultValue hidden value="">---Bahnhof wählen---</option>
                        {bhfList.map(bhf => <option value={parseInt(bhf.id)} key={bhf.id}>{bhf.bahnhof}</option>)}
                    </MyModalContentSelectInput>
                )
            case 'id_bhfende':
                return (
                    <MyModalContentSelectInput name={what} onChange={e => addNew(e, what)} required>
                        <option key={0} defaultValue hidden value="">---Bahnhof wählen---</option>
                        {bhfList.map(bhf => <option value={bhf.id} key={bhf.id}>{bhf.bahnhof}</option>)}
                    </MyModalContentSelectInput>
                )
            case 'kreisId':
                return (
                    <MyModalContentSelectInput name={what} onChange={e => addNew(e, what)} required>
                        <option key={0} defaultValue hidden value="">---Kreis wählen---</option>
                        {kreisList.map(item => <option value={item.id} key={item.id}>{item.kreis}</option>)}
                    </MyModalContentSelectInput>
                )
            case 'zvId':
                return (
                    <MyModalContentSelectInput name={what} onChange={e => addNew(e, what)} required>
                        <option key={0} defaultValue hidden value="">---Zweckverband wählen---</option>
                        {zvList.map(item => <option value={item.id} key={item.id}>{item.verband}</option>)}
                    </MyModalContentSelectInput>
                )
            case 'eiuId':
                return (
                    <MyModalContentSelectInput name={what} onChange={e => addNew(e, what)} required>
                        <option key={0} defaultValue hidden value="">---Eiu wählen---</option>
                        {eiuList.map(item => <option value={item.id} key={item.id}>{item.eiu}</option>)}
                    </MyModalContentSelectInput>
                )
            case 'strKatId':
                return (
                    <MyModalContentSelectInput name={what} onChange={e => addNew(e, what)} required>
                        <option key={0} defaultValue hidden value="">---Streckenkategorie wählen---</option>
                        {strkatList.map(item => <option value={item.id} key={item.id}>{item.kategorie}</option>)}
                    </MyModalContentSelectInput>
                )
            default:
                console.log('Unknown column: ', what);
                break;
        }
    }

    const addNew = (event, attr) => {
        // console.log(event.target.value, attr);
        setNewAbschnitt(previous => ({ ...previous, [attr]: event.target.value }));
    };

    const submitForm = event => {
        event.preventDefault();

        absInstance.createAbschnittAbschnittPost(newAbschnitt, (error, data, response) => {
            if (error) {
                FehlerauswertungErrResp(error, response);
            } else {
                alert(`Neuer Abschnitt ${data.name} hinzugefügt.\nMit id: ${data.id}`);
                closeModal(event);
                reloadData();
            }
        });
    }

    const closeModal = () => {
        setShowModal(false);
    };

    useKeypress('Escape', () => {
        closeModal();
    });


    return (
        <div>
            <MyNewButton onClick={openModal}>&#43; neuer Abschnitt</MyNewButton>
            <Modal isOpen={showModal} className="modal">
                <MyModalCloseButton onClick={closeModal}>&#10007; </MyModalCloseButton>
                <MyModalForm onSubmit={submitForm}>
                    <h3>Neuer Abschnitt:</h3>
                    <aside>Reihenfolge der Bahnhöfe ist nicht relevant</aside>
                    {listDropdowns.map(it =>
                        <MyModalContentRow>
                            <label>{it.Header}:
                                {tinkerDropdowns(it.accessor)}
                            </label>
                        </MyModalContentRow>

                    )}
                    <MyModalContentRow>
                        <label>Gültigkeitsbeginn:
                            <MyModalContentDateInput max={newAbschnitt.gueltigBis} onChange={e => addNew(e, 'gueltigVon')} required />
                        </label>
                    </MyModalContentRow>

                    <MyModalContentRow>
                        <label>Gültigkeitsende (optional):
                            <MyModalContentDateInput min={newAbschnitt.gueltigVon} onChange={e => addNew(e, 'gueltigBis')} />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Länge (in m):
                            <MyModalContentNumberInput onChange={e => addNew(e, 'distanz')} required />
                        </label>
                    </MyModalContentRow>
                    <MyModalContentRow>
                        <label>Kommentar:
                            <MyModalContentTextInput onChange={e => addNew(e, 'kommentar')} />
                        </label>
                    </MyModalContentRow>

                    <MyModalButtons>
                        <MySaveButton type="submit">Speichern</MySaveButton>
                        <MyCancelButton onClick={closeModal}>Abbruch</MyCancelButton>
                    </MyModalButtons>
                </MyModalForm>
            </Modal>
        </div >
    );

}
